import React from "react";
import PropTypes from "prop-types";
import { Spring, config, animated } from "react-spring";
import { Box } from "grid-styled";
import styled from "styled-components";
import * as colors from "../settings/colors";
import modalWrapper from "../hocs/modalWrapper";

const ModalBackdrop = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  z-index: 1000;
  overflow-y: auto;
`;

const ModalWindow = styled(animated.div)`
  position: fixed;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.6);
  width: 100%;
  max-width: 450px;
  margin: 20px 0;
  z-index: 1001;
`;

// TODO: Allow esc to close modal

class Modal extends React.Component {
  handleBackdropClick = e => {
    if (e.target !== e.currentTarget) return;
    this.props.close();
  };

  render() {
    const { isOpen, title, style, children } = this.props;

    return [
      <Spring
        key="backdrop"
        native
        to={{ opacity: isOpen ? 0.4 : 0 }}
        config={config.stiff}
      >
        {({ opacity }) => (
          <ModalBackdrop
            onClick={this.handleBackdropClick}
            style={{
              opacity,
              display: opacity.interpolate(
                opacity => (opacity > 0 ? "block" : "none")
              )
            }}
          />
        )}
      </Spring>,
      <Spring
        key="window"
        native
        to={{
          opacity: isOpen ? 1 : 0,
          y: isOpen ? 0 : 120
        }}
        config={config.stiff}
      >
        {({ opacity, y }) => (
          <ModalWindow
            style={{
              ...style,
              opacity,
              display: opacity.interpolate(
                opacity => (opacity > 0 ? "block" : "none")
              ),
              transform: y.interpolate(
                y => `translate3d(-50%, calc(-50% - ${y}px), 0)`
              )
            }}
          >
            {title && (
              <Box
                style={{
                  background: colors.DIVIDER,
                  borderRadius: "4px 4px 0 0"
                }}
                py="12px"
                px={2}
              >
                <b style={{ fontSize: 14, fontWeight: 600 }}>{title}</b>
              </Box>
            )}
            {isOpen && children}
          </ModalWindow>
        )}
      </Spring>
    ];
  }

  static propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func.isRequired,
    title: PropTypes.string
  };
}

export default modalWrapper(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal.js